var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 16.375,
    height: 16.375,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621",
    transform: "translate(-929 -503)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 22,
    height: 22,
    transform: "translate(929 503)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(932 506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M0,1.889A1.889,1.889,0,0,1,1.889,0h12.6a1.889,1.889,0,0,1,1.889,1.889v6.3a.63.63,0,0,1-1.26,0v-6.3a.63.63,0,0,0-.629-.63H1.889a.63.63,0,0,0-.629.63v12.6a.63.63,0,0,0,.629.63h6.3a.63.63,0,1,1,0,1.26h-6.3A1.89,1.89,0,0,1,0,14.485Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M11.546,9.657a1.889,1.889,0,1,0,1.889,1.889,1.889,1.889,0,0,0-1.889-1.889M8.4,11.546a3.149,3.149,0,1,1,3.149,3.149A3.149,3.149,0,0,1,8.4,11.546",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M13.154,12.833a.629.629,0,0,1,.885-.1l2.1,1.679a.63.63,0,0,1-.787.984l-2.1-1.68A.63.63,0,0,1,13.154,12.833Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M3.359,4.829a.63.63,0,0,1,.63-.63h8.4a.63.63,0,0,1,0,1.26h-8.4a.63.63,0,0,1-.63-.63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M3.359,8.187a.63.63,0,0,1,.63-.63H7.348a.63.63,0,0,1,0,1.26H3.989a.63.63,0,0,1-.63-.63",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverview);
export default __webpack_public_path__ + "static/media/icon-overview.137e21dc5c3b9abab2cd4c9e6b8c3301.svg";
export { ForwardRef as ReactComponent };